import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from './components/utils/EntraUtils/AuthConfig';
import { useHistory } from 'react-router-dom';
import { setCurrentUserId, setIsUserLoggedIn } from './redux/actions/uiActions';

import config from './config';
//import logo from './logo.svg';

import { getCurrentRegionAPIConfigs } from './components/utils/APIsUtils/httpsUtils';
import Notification from './components/shared/notification';
import { autoAssignSegment, fetchSegmentList, setIsSegmentAssigned } from './redux/actions/segment/segmentActions';
import { parseJwt } from './components/utils/commonUtil';
import { setOktaUserInfo } from './redux/actions/commonDataActions';
import { constants } from './constants';
// const currentRegionOIDCConfigs = getCurrentRegionOIDCConfigs(); // Not needed for MSAL logic here directly
const currentRegionAPIConfigs = getCurrentRegionAPIConfigs();


const Login = ({ setIsUserLoggedIn, setCurrentUserId }) => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const history = useHistory();
  const dispatch = useDispatch();
  const { notificationData } = useSelector(state => state?.uiState);


  return (
    <div className="login-container">
      <div className="login-loading">
        Loading...
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setIsUserLoggedIn: (options) => dispatch(setIsUserLoggedIn(options)),
  setCurrentUserId: (options) => dispatch(setCurrentUserId(options)),
});

export default React.memo(connect(null, mapDispatchToProps)(Login));
